// Mock data for Next Level Landing Page

export const siteConfig = {
  name: "Next Level",
  tagline: "Performance. Ausbildung. Scouting.",
  domain: "next-level.es",
};

export const navigation = [
  { label: "Gurzí MotionLab", href: "#motion-lab" },
  { label: "Academy", href: "#academy" },
  { label: "Scouting", href: "#scouting" },
  { label: "Goats of Sports", href: "#goats" },
  { label: "Kontakt", href: "#kontakt" },
];

export const heroContent = {
  headline: "Dein nächstes Level beginnt hier.",
  subline: "Next Level vereint Gurzí MotionLab, Academy und Scouting in einem System, das Performance sichtbar macht und Entwicklung beschleunigt.",
  founderQuote: "Wir stehen für Innovation und Lösungen.",
  founderName: "Domenico Gurzi",
  founderRole: "Geschäftsführer",
  ctaPrimary: "Early Access sichern",
  ctaSecondary: "Bereiche entdecken",
  backgroundImage: "https://images.unsplash.com/photo-1612607696387-f139f76bdd6c?w=1920&q=80",
};

export const comingSoonContent = {
  badge: "Coming Soon",
  headline: "Was bald kommt",
  description: "Next Level baut gerade die neue Plattform und die Programme aus. Unser Ziel: Spielerentwicklung messbar machen, Training skalieren – durch E-Learning und Live-Einheiten –, Talente sichtbar machen durch professionelles Scouting und Community sowie Content über Goats of Sports bündeln.",
  highlights: [
    { label: "Messbare Entwicklung", description: "Performance-Daten, die zählen" },
    { label: "Hybrides Training", description: "E-Learning + Live auf dem Platz" },
    { label: "Talent-Sichtbarkeit", description: "Professionelles Scouting-Netzwerk" },
    { label: "Community & Content", description: "Goats of Sports Plattform" },
  ],
};

export const pillars = [
  {
    id: "motion-lab",
    title: "Gurzí MotionLab",
    shortDescription: "Hightech-Bewegungsanalyse, Screening, Performance-Checks und belastbare Handlungsempfehlungen für Training und Prävention.",
    cta: "Go to Gurzí MotionLab",
    icon: "Activity",
  },
  {
    id: "academy",
    title: "Football Academy",
    subtitle: "Football Training & Youth Academy",
    shortDescription: "Hybrid-Programm aus Videomodulen, Trainingsplänen, Aufgaben, Feedback und Live-Einheiten. Ideal für Spieler, die konstant besser werden wollen.",
    cta: "Academy starten",
    icon: "GraduationCap",
  },
  {
    id: "scouting",
    title: "Football Scouting",
    shortDescription: "Scouting- und Talent-Programme mit Profiling, Videoanalyse, Entwicklungspfad und Verbindung ins Netzwerk. Leistung sichtbar machen.",
    cta: "Scouting anfragen",
    icon: "Search",
  },
  {
    id: "goats",
    title: "Goats of Sports",
    shortDescription: "Unsere externe Plattform für Content, Community und Spotlight auf Athleten. Hier entsteht die Bühne für die nächste Generation.",
    cta: "Zu Goats of Sports",
    icon: "Trophy",
  },
];

export const motionLabDetail = {
  headline: "Gurzí MotionLab",
  tagline: "High Performance trifft Wissenschaft",
  description: "Das Gurzí MotionLab ist das Herzstück von Next Level. Hier treffen modernste Bewegungsanalyse, Leistungsdiagnostik und wissenschaftliche Methodik aufeinander – für Handlungsempfehlungen, die wirklich etwas verändern.",
  steps: [
    {
      step: "01",
      title: "Analyse",
      description: "Bewegungs- und Leistungsstatus aufnehmen. Detaillierte Erfassung aller relevanten Parameter.",
    },
    {
      step: "02",
      title: "Interpretation",
      description: "Schwachstellen, Risiken und Potenziale identifizieren. Datenbasiert und objektiv.",
    },
    {
      step: "03",
      title: "Plan",
      description: "Konkrete Maßnahmen für Training, Prävention und Return-to-Play. Individuell und umsetzbar.",
    },
  ],
  cta: "Go to Gurzí MotionLab",
  images: {
    main: "/images/motionlab.jpg",
  },
};

export const academyDetail = {
  headline: "Football Academy",
  tagline: "Football Training & Youth Academy",
  description: "Unser Hybrid-Programm verbindet digitales Lernen mit intensivem Platztraining. Struktur, Fortschritt und individuelle Betreuung – alles in einem System.",
  features: [
    {
      title: "E-Learning Bibliothek",
      description: "Technik, Athletik, Mindset, Taktik – strukturiert und jederzeit abrufbar.",
    },
    {
      title: "Live Training",
      description: "Auf dem Platz, ergänzt durch direktes Feedback und Coaching.",
    },
    {
      title: "Individualisierung",
      description: "Klare Ziele, Messpunkte und Aufgaben zwischen den Sessions.",
    },
  ],
  cta: "Auf Warteliste",
  image: "/images/pillars-1.jpg",
};

export const scoutingDetail = {
  headline: "Football Scouting",
  tagline: "Talent sichtbar machen",
  description: "Unser Scouting-Programm verbindet objektive Leistungsbewertung mit einem starken Netzwerk. Wir machen Potenziale sichtbar und öffnen Türen.",
  features: [
    {
      title: "Spieler-Profiling",
      description: "Position, Stärken, Entwicklungsfelder – klar und nachvollziehbar aufbereitet.",
    },
    {
      title: "Video & Performance Review",
      description: "Objektiver Blick auf Spielszenen, Bewegungsmuster und Leistungsdaten.",
    },
    {
      title: "Matchmaking",
      description: "Perspektiven aufzeigen, Empfehlungen aussprechen, Kontakte herstellen.",
    },
  ],
  cta: "Scouting Gespräch buchen",
  image: "/images/scouting.jpg",
};

export const goatsContent = {
  headline: "Goats of Sports",
  tagline: "Content. Community. Spotlight.",
  description: "Goats of Sports ist unsere externe Plattform, auf der Athleten eine Bühne bekommen, Content geteilt wird und eine Community entsteht, die den Sport feiert.",
  cta: "Goats of Sports öffnen",
  image: "/images/goats.jpg",
};

export const founderContent = {
  name: "Domenico Gurzi",
  role: "Geschäftsführer",
  bio: "Domenico Gurzi ist Sport- und Bewegungswissenschaftler, Diplom Reha- und Athletiktrainer mit langjähriger Erfahrung im Profi-Fußball. Als Geschäftsführer von Next Level verbindet er wissenschaftliche Expertise mit einer klaren Vision: Spielerentwicklung auf ein neues Level zu bringen – mit Sitz in Marbella, Spanien.",
  quote: "Wir stehen für Innovation und Lösungen. Next Level ist die konsequente Weiterentwicklung unserer Arbeit – ein System, das Spieler wirklich weiterbringt.",
  image: "/images/founder.jpg",
  location: "Marbella, Spanien",
};

export const contactContent = {
  headline: "Sichere dir Early Access",
  subline: "Sichere dir Early Access und Updates zum Launch.",
  roles: [
    { value: "spieler", label: "Spieler" },
    { value: "eltern", label: "Eltern" },
    { value: "coach", label: "Coach" },
    { value: "club", label: "Club" },
    { value: "scout", label: "Scout" },
  ],
  cta: "Absenden",
  checkboxLabel: "Ich möchte über Programme und Termine informiert werden.",
};

export const galleryContent = {
  headline: "Impressions",
  tagline: "Behind the Scenes",
  images: [
    { src: "/images/gallery-1.jpg", alt: "With Luka Modrić – Trophy Room" },
    { src: "/images/gallery-2.jpg", alt: "Domenico Gurzi & Luka Modrić" },
    { src: "/images/gallery-3.jpg", alt: "Training Session – Marbella" },
    { src: "/images/gallery-4.jpg", alt: "Sky Sport – Box2Box" },
    { src: "/images/gallery-5.jpg", alt: "Biomechanics Presentation" },
    { src: "/images/gallery-6.jpg", alt: "Coaching on the Pitch" },
    { src: "/images/gallery-7.jpg", alt: "Individual Training Session" },
  ],
};

export const logoImage = "/images/logo.jpg";

export const footerContent = {
  links: [
    { label: "Impressum", href: "#" },
    { label: "Datenschutz", href: "#" },
    { label: "Cookie-Einstellungen", href: "#" },
  ],
  socials: [
    { platform: "Instagram", href: "#", icon: "Instagram" },
  ],
  copyright: `© ${new Date().getFullYear()} Next Level. Alle Rechte vorbehalten.`,
};
